import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import cls from 'classnames'
import { Controller } from 'react-hook-form'

import { useNewReportForm } from '../../use-new-report-form'
import { useStyles } from './styles'

function SortOptionsInput() {
  const classes = useStyles()
  const { control } = useNewReportForm()

  return (
    <Box className={cls(classes.formGroup, classes.border)}>
      <Typography variant='body1'>Ordenar diagnósticos por:</Typography>
      <FormControl>
        <Controller
          name='sort_options'
          control={control}
          defaultValue={'demand_name'}
          render={({ field }) => (
            <RadioGroup {...field}>
              <FormControlLabel
                control={<Radio size='small' value='demand_name' />}
                label={
                  <Typography variant='subtitle1'>
                    Nome do diagnóstico (A-Z)
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='-demand_name' />}
                label={
                  <Typography variant='subtitle1'>
                    Nome do diagnóstico (Z-A)
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='created_at' />}
                label={
                  <Typography variant='subtitle1'>
                    Data de cadastro (mais recente)
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='-created_at' />}
                label={
                  <Typography variant='subtitle1'>
                    Data de cadastro (mais antigo )
                  </Typography>
                }
              />

              <FormControlLabel
                control={<Radio size='small' value='total_area' />}
                label={
                  <Typography variant='subtitle1'>
                    Área total (crescente)
                  </Typography>
                }
              />
              <FormControlLabel
                control={<Radio size='small' value='-total_area' />}
                label={
                  <Typography variant='subtitle1'>
                    Área total (decrescente)
                  </Typography>
                }
              />
            </RadioGroup>
          )}
        />
      </FormControl>
    </Box>
  )
}

export default SortOptionsInput
